<template>
    <div>
        <div class="head_label">Логотип</div>
        <div style="clear:both"></div>
        <div class="logo">
            <img :src="image"/>
        </div>
        <div class="logo-input">
            <label for="logo" class="control-label">ИЗМЕНИТЬ</label>
            <div class="fileform">
                <div class="selectbutton">Открыть</div>
                <input id="upload" type="file" name="logo_upload" @change="onFileChange"/>
                {{name}}
                <input type="hidden" name="logo" :value="image"/>
            </div>
            <button @click="removeImage" type="button" class="btn btn-primary btn-sm">Удалить</button>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import _ from 'lodash'

    export default {
        data() {
            return {
                image: '',
                name: ''
            }
        },
        props: ['salon_id', 'logo'],
        methods: {
            onFileChange(e) {
                var files = e.target.files || e.dataTransfer.files
                if (!files.length)
                    return

                return this.createImage(files[0], files[0].name)
            },
            createImage(file, file_name) {
                var reader = new FileReader()
                reader.onload = (e) => {
                    this.image = e.target.result
                    this.name = file_name
                };
                reader.readAsDataURL(file)

                return this.name
            },
            removeImage: function (e) {
                this.image = ''
                this.name = ''
            }
        },
        mounted() {
            this.name = this.logo
            this.image = this.logo
        }
    }
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// SalonFormImage.vue?cc099476